export { AtnActionDialogComponent as Component } from './action.component'
